import { buildVarOptions } from '../../lib/varSelectOptions.js'
import { nodeControlClass } from '../../lib/nodeControlClass.js'

/**
 * The variable dropdown shared by every node that names a variable — Set
 * Variable and the array / map ops. One component so they cannot drift: it grew
 * out of a copy local to ArrayMapNodes.jsx, while Set Variable had a free-text
 * field and no list at all.
 *
 * `variables` is the EDITOR's live list (`data.variables`, injected by
 * EventGraph), not the `animVariables` module — so a variable added in the MY
 * BLUEPRINT rail appears here on the same render, rather than on the next
 * 100 ms debug poll.
 *
 * `filterType` narrows to one type (the array / map ops need that); omit it and
 * every variable is offered with its type shown. A value the node holds that
 * cannot be listed is still rendered, disabled, with the reason — see
 * varSelectOptions.js for why that matters.
 */
const FIELD_CLASS = nodeControlClass()

export function VarSelect({ value, onChange, variables, filterType, accent, testId, style }) {
  const { options, problem } = buildVarOptions(variables, { filterType, current: value })
  const stop = e => e.stopPropagation()

  return (
    <select
      className={FIELD_CLASS}
      value={value ?? ''}
      onChange={e => onChange?.(e.target.value)}
      onMouseDown={stop}
      data-testid={testId}
      style={{
        flex: 1, minWidth: 0, background: '#040608',
        border: `1px solid ${problem ? '#e0805044' : `${accent}44`}`,
        color: problem ? '#e08050' : accent,
        padding: '2px 5px', borderRadius: 3,
        fontSize: 10, fontFamily: 'var(--m-mono)', outline: 'none', cursor: 'pointer',
        ...style,
      }}
    >
      {options.map(o => (
        <option key={o.value || '__none__'} value={o.value} disabled={o.disabled}>{o.label}</option>
      ))}
    </select>
  )
}

export default VarSelect
